import {
  CREATE_COMM_DAIRY_FERTILIZATION_EXCEL,
  GENERATE_SIGN_OFF_EMAIL,
  GET_CURRENT_FERT_PREDICTION_TECH,
  GET_FERTILIZATION_LIST,
  GET_FERTILIZATION_LIST_FREEZE,
  GET_FERTILIZATION_QC_DATA,
  GET_SHIPMENT_GROUP_MASTERS,
  TOA_GetFertilizationsForFreezing,
  TOA_GetFreshShipmentFertList,
  UPDATE_FERT_TRANSACTION,
  UPDATE_FERT_TRANSACTION_FREEZE,
  UPDATE_INCUBATOR_ASSIGNMENT,
  UPDATE_MATING_LABELS,
  UPDATE_MATING_LABELS_DUPES,
} from '@/rtk-query.gql';

import { enhancedApi } from '../api/baseApi';

export const fertilizationsApi = enhancedApi.injectEndpoints({
  endpoints: (build) => ({
    getFertilizationList: build.query({
      query: (variables) => ({
        document: GET_FERTILIZATION_LIST,
        variables,
      }),
      providesTags: ['FertilizationListFreshShipment'],
      transformResponse: (response: {
        fertilizationList: TOA_GetFreshShipmentFertList[];
      }) => {
        return response.fertilizationList;
      },
    }),
    getFertilizationQcData: build.query({
      query: (variables) => ({
        document: GET_FERTILIZATION_QC_DATA,
        variables,
      }),
      providesTags: ['FertilizationQcData'],
    }),
    getShipmentGroupMasters: build.query({
      query: (variables) => ({
        document: GET_SHIPMENT_GROUP_MASTERS,
        variables,
      }),
      providesTags: ['ShipmentGroupMasters'],
    }),
    getCurrentFertPredictionTech: build.query({
      query: (variables) => ({
        document: GET_CURRENT_FERT_PREDICTION_TECH,
        variables,
      }),
      providesTags: ['CurrentFertPredictionTech'],
    }),
    getFertilizationListFreeze: build.query({
      query: (variables) => ({
        document: GET_FERTILIZATION_LIST_FREEZE,
        variables,
      }),
      providesTags: ['FertilizationListFreeze'],
      transformResponse: (response: {
        fertilizationListFreeze: TOA_GetFertilizationsForFreezing[];
      }) => response.fertilizationListFreeze,
    }),
    updateFertTransaction: build.mutation({
      query: (variables) => ({
        document: UPDATE_FERT_TRANSACTION,
        variables,
      }),
    }),
    updateMatingLabels: build.mutation({
      query: (variables) => ({
        document: UPDATE_MATING_LABELS,
        variables,
      }),
      invalidatesTags: ['FertilizationListFreshShipment'],
    }),
    updateMatingLabelsDupes: build.mutation({
      query: (variables) => ({
        document: UPDATE_MATING_LABELS_DUPES,
        variables,
      }),
      invalidatesTags: ['FertilizationListFreshShipment'],
    }),
    updateIncubatorAssignment: build.mutation({
      query: (variables) => ({
        document: UPDATE_INCUBATOR_ASSIGNMENT,
        variables,
      }),
    }),
    updateFertTransactionFreeze: build.mutation({
      query: (variables) => ({
        document: UPDATE_FERT_TRANSACTION_FREEZE,
        variables,
      }),
    }),
    signOff: build.mutation({
      query: (variables) => ({
        document: GENERATE_SIGN_OFF_EMAIL,
        variables,
      }),
      invalidatesTags: ['FertilizationListFreshShipment'],
    }),
    createCommDairyFertilizationList: build.mutation({
      query: (variables) => ({
        document: CREATE_COMM_DAIRY_FERTILIZATION_EXCEL,
        variables,
      }),
    }),
  }),
});

export const {
  useGetFertilizationListQuery,
  useLazyGetFertilizationListQuery,
  useGetFertilizationQcDataQuery,
  useGetShipmentGroupMastersQuery,
  useCreateCommDairyFertilizationListMutation,
  useGetCurrentFertPredictionTechQuery,
  useUpdateFertTransactionMutation,
  useUpdateMatingLabelsMutation,
  useUpdateMatingLabelsDupesMutation,
  useUpdateIncubatorAssignmentMutation,
  useSignOffMutation,
  useLazyGetCurrentFertPredictionTechQuery,
  useLazyGetFertilizationQcDataQuery,
  useUpdateFertTransactionFreezeMutation,
  useGetFertilizationListFreezeQuery,
} = fertilizationsApi;
